import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetAmountBeDeductedViewupSnsAccountResponse } from 'viewup-api/v2';

export type GetAmountReq = {
  snsAccountUuid: string;
};
export type GetAmountRes = GetAmountBeDeductedViewupSnsAccountResponse;

export const getAmount = async (params: GetAmountReq): Promise<GetAmountRes> => {
  const { snsAccountUuid } = params;
  const response = await serviceApi.snsAccount.getAmountBeDeductedViewupSnsAccount(
    withServiceRequestDefaults({
      snsAccountUuid,
    }),
  );

  return response.data;
};
